import { render, staticRenderFns } from "./sample-filters.vue?vue&type=template&id=08d434d9&"
import script from "./sample-filters.vue?vue&type=script&lang=js&"
export * from "./sample-filters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports